import { Stack, Typography } from '@mui/material'
import { type SurveyElement } from '../MidYearSummary'

export const SummaryHeader = ({ element }: { element: SurveyElement }): JSX.Element => {
  return (
    <Stack direction='row' alignItems='center' gap={1} mt={4}>
      <Typography variant='h4'>{element.text}</Typography>
      {element.description != null && element.description !== '' && (
        <Typography variant='body2' color='text.secondary'>{element.description}</Typography>
      )}
    </Stack>
  )
}
